import axios, { AxiosRequestConfig } from 'axios';
import config from '.././Config';
import { getHeaders } from './HeaderService';
import { activityHistoryEntry } from '../types/definitions/ActivityHistoryEntry';

const getActivityHistoryList = async (userId: string, token: string, clientId: string) => {
    const callUrl = `${config.searchApi.activityHistoryGetUrl}/${userId}`;
    const resultActivityHistory = await axios.request({
        method: 'GET',
        url: callUrl,
        headers: getHeaders(token, clientId),
    });

    return resultActivityHistory;
};

const postActivityHistory = async (
    data: Array<activityHistoryEntry>,
    userId: string,
    token: string
) => {
    const callUrl = `${config.searchApi.activityHistoryPostUrl}/${userId}`;

    const axconfig = {
        headers: getHeaders(token, ''),
    };
    await axios.post(callUrl, data, axconfig);
};

const deleteActivityHistory = async (userId: string, token: string, clientId: string) => {
    const callUrl = `${config.searchApi.activityHistoryDeleteUrl}/${userId}`;
    var resultActivityHistory = await axios.request({
        method: 'GET',
        url: callUrl,
        headers: getHeaders(token, clientId),
    });

    return resultActivityHistory;
};

const deleteCache = async (userId: string, token: string, clientId: string) => {
    const callUrl = `${config.searchApi.deleteCacheUrl}/${userId}`;
    var resultDeleteCache = await axios.request({
        method: 'GET',
        url: callUrl,
        headers: getHeaders(token, clientId),
    });

    return resultDeleteCache;
};

export default {
    getActivityHistoryList,
    postActivityHistory,
    deleteActivityHistory,
    deleteCache,
};
